import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import Input, { Size as InputSize } from '@jetbrains/ring-ui/components/input/input';
import { ConfigureModelDialog } from '@modules/ai/common/forms/common/provider-models';
import { Required } from '@common/form/important-asterisk';
import { assignTestId } from '@common/infra/tests/assign-test-id';
import RegisteredInput from '@common/hook-form/registered-input';
import { tAzureOpenAiPlatformModel } from '../../open-ai-form-schema';
export function AzureModelConfigurationDialog(props) {
    var _a;
    const { model, type, onCloseAttempt, modelConfigurations } = props;
    const form = useForm({
        defaultValues: model !== null && model !== void 0 ? model : {
            id: type,
            modelName: type
        },
        resolver: zodResolver(tAzureOpenAiPlatformModel),
        mode: 'onChange'
    });
    const { formState, handleSubmit, watch } = form;
    const handleSave = handleSubmit(onCloseAttempt);
    const handleClose = useCallback(() => onCloseAttempt(undefined), [onCloseAttempt]);
    return (_jsxs(ConfigureModelDialog, { modelTypeName: (_a = modelConfigurations.find(model => model.id === type)) === null || _a === void 0 ? void 0 : _a.label, onSave: handleSave, onCancel: handleClose, formState: formState, children: [_jsx(Input, { value: watch('id'), label: "ID", size: InputSize.L, disabled: true }), _jsx(Input, { value: watch('modelName'), label: "Model name", size: InputSize.L, disabled: true }), _jsx(RegisteredInput, { name: "deploymentName", control: form.control, label: Required('Deployment name'), size: InputSize.L, ...assignTestId('deployment-name') })] }));
}
